import React from 'react';
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from './ui/alert-dialog';

// Confirm dialog for destructive/irreversible actions — states the consequence
export const ConfirmDialog = ({ open, onOpenChange, title, consequence, confirmLabel, destructive, onConfirm, busy }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="confirm-dialog" className="max-w-sm rounded-2xl">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{consequence}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-dialog-cancel" className="rounded-xl">Cancel</AlertDialogCancel>
        <AlertDialogAction
          data-testid="confirm-dialog-confirm"
          disabled={busy}
          className={`rounded-xl ${destructive ? 'bg-[hsl(var(--destructive))] hover:bg-[hsl(var(--destructive))]/90' : ''}`}
          onClick={onConfirm}
        >
          {busy ? 'Working…' : confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
